@if (currentSection === 'manifestInfo') {
<div class="py-200-rem px-250-rem h-full">
  <div class="flex flex-col space-y-050-rem">
    <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Manifest information</h1>
    <p class="text-container-fg-muted text-label-md-weight-regular">
      Please review the manifest content.
    </p>
  </div>
  <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-3xl gap-3 flex flex-col">
    <h2 class="text-container-fg-default text-label-lg-weight-medium">
      Manifest content
    </h2>
    <div>
      <p>manifest.xml</p>
      <div class="-mr-100-rem shiki">
        <div [innerHTML]="extractedXmlContent()" class="whitespace-pre-wrap"></div>
      </div>
    </div>
  </div>
</div>
}
